import { render } from "./Index.vue?vue&type=template&id=4f6dacf6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4f6dacf6&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=4f6dacf6&lang=css"

import exportComponent from "/www/wwwroot/check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6dacf6"]])

export default __exports__